import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import AuthSettingsItemHeader from '../../components/common/AuthSettingsItemHeader';
import { DashboardButton } from '../../components/common/Button';
import { InputWord } from '../../components/common/Input';
import { ToastQueueRefContext } from '../../components/common/Toast';
import { updateEmailSchema, updateEmailType } from '../../schema/DashboardSchema';
import UsersService from '../../services/users.service';

const DashboardAuthenticationEmailComponent = () => {
  const navigate = useNavigate();
  const usersService = new UsersService();
  const toastQueueRef = useContext(ToastQueueRefContext);
  const { logout } = useAuth();

  const updateEmailMethods = useForm<updateEmailType>({
    resolver: yupResolver(updateEmailSchema),
    mode: 'onSubmit',
    defaultValues: {
      newEmail: '',
      confirmNewEmail: '',
    },
  });

  const confirmUpdateEmail = async ({ confirmNewEmail }: updateEmailType) => {
    await usersService.updateEmail({
      email: confirmNewEmail,
    });

    toastQueueRef?.current?.addToast({
      type: 'SUCCESS',
      description: 'Email mis à jour',
      timer: 5000,
    });

    logout();
    navigate('/login', { replace: true });
  };

  return (
    <>
      <AuthSettingsItemHeader title='Modifier votre adresse e-mail' description='Modifier votre adresse e-mail de connexion' />
      <FormProvider {...updateEmailMethods}>
        <form onSubmit={updateEmailMethods.handleSubmit(confirmUpdateEmail)}>
          <div className='w-1/2 max-md:w-full'>
            <Controller
              name='newEmail'
              control={updateEmailMethods.control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <InputWord
                  label='Nouvelle adresse e-mail'
                  type='text'
                  placeholder='exemple@email.com'
                  value={value}
                  onChangeValue={onChange}
                  errorMessage={error?.message}
                />
              )}
            />
          </div>
          <div className='w-1/2 max-md:w-full'>
            <Controller
              name='confirmNewEmail'
              control={updateEmailMethods.control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <InputWord
                  label='Confirmer la nouvelle adresse e-mail'
                  type='text'
                  placeholder='exemple@email.com'
                  value={value}
                  onChangeValue={onChange}
                  errorMessage={error?.message}
                />
              )}
            />
          </div>
          <div className='mt-6 flex justify-end'>
            <DashboardButton type='cancel' onClick={() => navigate('/dashboard/authentication')} />
            <DashboardButton type='confirm' />
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default DashboardAuthenticationEmailComponent;
